import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface PageContainerProps {
  children: ReactNode;
  className?: string;
  maxWidth?: "4xl" | "5xl" | "6xl" | "7xl" | "full";
  padding?: "sm" | "md" | "lg" | "xl";
}

export default function PageContainer({ 
  children, 
  className,
  maxWidth = "7xl",
  padding = "lg"
}: PageContainerProps) {
  const maxWidthClasses = {
    "4xl": "max-w-4xl",
    "5xl": "max-w-5xl", 
    "6xl": "max-w-6xl",
    "7xl": "max-w-7xl",
    "full": "max-w-full"
  };

  const paddingClasses = {
    "sm": "py-8 px-4 sm:px-6 lg:px-8",
    "md": "py-12 px-4 sm:px-6 lg:px-8", 
    "lg": "py-16 px-4 sm:px-6 lg:px-8",
    "xl": "py-20 px-4 sm:px-6 lg:px-8"
  };

  return (
    <div className={cn(
      paddingClasses[padding],
      maxWidthClasses[maxWidth],
      "mx-auto",
      className
    )}>
      {children}
    </div>
  );
}
